import classNames from 'classnames';
import React from 'react';
import { CATEGORY } from '../../../constants';
import LinkMore from '../LinkMore/LinkMore';

const Alerts = ({ alerts, isFetchingAlerts }) => {

    const alertInfoClasses = classNames('alert-info', {
        'alert-info--urgent': alert.priority === 'high',
        'alert-info--single': alerts.length === 1
    });
    if (isFetchingAlerts || !alerts?.length > 0) {
        return null;
    }

    return alerts.map(alert => (
        <div key={alert.id} className={alertInfoClasses} data-cy="alert">
            <h2 className="alert-info__header">{alert.name}</h2>
            <p className="alert-info__text">{alert.description}</p>
            <LinkMore
                contentId={`${CATEGORY.alerts}/${alert.id}`}
                name={alert.name}
                additionalClassNames="alert-info__link"
            />
        </div>
    ));
};

export default Alerts;
